import useCompany, {
  CompanyOptions,
  CompanyVars,
} from '@vangst/services/oogst/company/useCompany'
import Routes from '@vangst/services/routes'
import { memo } from 'react'
import useScroll from '../../components/hooks/useScroll'
import ClickyLink from '../../components/navigation/ClickyLink'

type PropsType = React.HTMLAttributes<HTMLDivElement> & {
  readonly at: 'content' | 'sidebar' // Not using yet
  readonly variables: CompanyVars
  readonly options?: CompanyOptions
}

// TODO: Move to lib and derive this data in the services hook
const formatLink = (link: string) => {
  return link.split('://').pop()?.split('www.').pop()
}

function CompanyBlockList(props: PropsType) {
  const { at, variables, options, ...rest } = props
  const { data } = useCompany(variables, options)
  const company = data?.getClient

  const { scrollToHash } = useScroll()

  return (
    <div {...rest}>
      <ul className="flow-y-xs mt-4 text-sm">
        <li className="text-md">Quick Links:</li>
        <li>
          <ClickyLink
            className="bullet link-orange ml-4 underline"
            onClick={() => scrollToHash('#about')}
          >
            About Us
          </ClickyLink>
        </li>
        {!!company?.countAvailablePositions && (
          <li>
            <ClickyLink
              className="bullet link-orange ml-4 underline"
              onClick={() => scrollToHash('#open-positions')}
            >
              Available Positions
            </ClickyLink>
          </li>
        )}
        {!!company?.trainings?.pageInfo.totalCount && (
          <li>
            <ClickyLink
              className="bullet link-orange ml-4 underline"
              href={`${Routes.COMPANIES_DETAIL.replace(
                ':displayname',
                company?.displayname || '',
              )}#training-courses`}
            >
              Training Courses
            </ClickyLink>
          </li>
        )}
      </ul>

      <ul className="flow-y-xs mt-4 text-sm">
        <li className="text-md">Headquarters & Company Size:</li>
        {company != null &&
        (company.location.address != null || company.citystatezip !== '') ? (
          <li className="bullet link-orange ml-4 underline">
            <ClickyLink
              href={`http://maps.google.com/?q=${company?.location?.address}, ${company?.citystatezip}`}
              className="link-orange grid"
            >
              {company?.location.address && (
                <span>{company.location.address}</span>
              )}{' '}
              {company?.citystatezip && <span>{company?.citystatezip}</span>}
            </ClickyLink>
          </li>
        ) : (
          <li className="bullet ml-4">Not available</li>
        )}
        <li className="bullet ml-4">
          {company?.companySizeChunk?.label?.replace('-', ' - ') ||
            'Not available'}
        </li>
      </ul>

      <dl className="mt-4 text-sm">
        <dt className="text-md">Website:</dt>
        <dd className="mt-2 flex items-center">
          {company?.website ? (
            <a
              className="bullet link-orange mb-2 ml-4 truncate"
              href={company.website}
              rel="noreferrer"
              target="_blank"
            >
              {company.webname}
            </a>
          ) : (
            <span>Not available</span>
          )}
        </dd>
      </dl>

      <dl className="flow-y-xs mt-4 text-sm">
        <dt className="text-md">Social Media Links:</dt>
        {company?.social?.linkedin && (
          <dd>
            <a
              className="bullet link-orange mb-2 ml-4 whitespace-nowrap"
              href={company.social?.linkedin}
              target="_blank"
              rel="noreferrer"
              title={company.social?.linkedin}
            >
              <span className="inline-block max-w-64 truncate underline">
                {formatLink(company.social?.linkedin)}
              </span>
            </a>
          </dd>
        )}
        {company?.social?.instagram && (
          <dd>
            <a
              className="bullet link-orange mb-2 ml-4 whitespace-nowrap"
              href={company.social?.instagram}
              target="_blank"
              rel="noreferrer"
              title={company.social?.instagram}
            >
              <span className="inline-block max-w-64 truncate underline">
                {formatLink(company.social?.instagram)}
              </span>
            </a>
          </dd>
        )}
        {company?.social?.twitter && (
          <dd>
            <a
              className="bullet link-orange mb-2 ml-4 whitespace-nowrap"
              href={company.social?.twitter}
              target="_blank"
              rel="noreferrer"
              title={company.social?.twitter}
            >
              <span className="inline-block max-w-64 truncate underline">
                {formatLink(company.social?.twitter)}
              </span>
            </a>
          </dd>
        )}
        {company?.social?.facebook && (
          <dd>
            <a
              className="bullet link-orange mb-2 ml-4 whitespace-nowrap"
              href={company.social?.facebook}
              target="_blank"
              rel="noreferrer"
              title={company.social?.facebook}
            >
              <span className="inline-block max-w-64 truncate underline">
                {formatLink(company.social?.facebook)}
              </span>
            </a>
          </dd>
        )}
        {!company?.social?.linkedin &&
          !company?.social?.instagram &&
          !company?.social?.twitter &&
          !company?.social?.facebook && <dd className="h-8">Not available</dd>}
      </dl>
    </div>
  )
}

export default memo(CompanyBlockList)
